import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

type Props = {
  open: boolean;
  onClose(): void;
  onConfirm(): void;
  country: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navLink: {
      color: 'var(--primary)',
      fontWeight: theme.typography.fontWeightMedium,
      textDecoration: 'none'
    },
    button: {
      borderRadius: '100px'
    },
    title: {
      [theme.breakpoints.down('md')]: {
        fontSize: 18
      }
    },
    text: {
      [theme.breakpoints.down('md')]: {
        fontSize: 14
      }
    },
    dialogPaper: {
      maxWidth: 600,
      [theme.breakpoints.down('xs')]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
      }
    }
  })
);
export const InfoDialog: React.FC<Props> = ({ open, onClose, country, onConfirm }) => {
  const { t } = useTranslation('signup');
  const classes = useStyles();
  const phone = country === 'AU' ? '+61 8 6186 3674' : '0345 521 9222';

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }} disableRestoreFocus>
      <DialogTitle>
        <Typography variant="h5" gutterBottom classes={{ root: classes.title }}>
          {t('fields.email.attention', 'Attention:')}
        </Typography>
        <Typography classes={{ root: classes.text }}>
          {t('fields.email.userExistsMessage', 'This email address is already registered on our system. If you are a:')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom classes={{ root: classes.text }}>
          <Trans i18nKey="fields.email.existingUser" ns="signup">
            <b>Existing User:</b>
            <br />
            Simply{' '}
            <a
              href="https://veriforceone.com/identity/Account/Login"
              rel="noopener noreferrer"
              target="_blank"
              className={classes.navLink}
            >
              log in
            </a>{' '}
            to your existing account.
            <br />
            Forgotten your password? No problem,{' '}
            <a
              href="https://veriforceone.com/identity/Account/ForgotPassword"
              rel="noopener noreferrer"
              target="_blank"
              className={classes.navLink}
            >
              reset it here.
            </a>
          </Trans>
        </Typography>
        <Typography gutterBottom classes={{ root: classes.text }}>
          <Trans i18nKey="fields.email.consultant" ns="signup">
            <b>Consultant:</b>
            <br />
            Looking to set up CHAS accreditation for a new contractor?
            <br />
            Please continue with the sign up. Afterwards,{' '}
            <a href="https://veriforce.com" rel="noopener noreferrer" target="_blank" className={classes.navLink}>
              log in
            </a>{' '}
            to continue.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogContent>
        <Typography gutterBottom classes={{ root: classes.text }}>
          <Trans i18nKey="fields.email.needHelp" ns="signup">
            Need any help? Our award-winning team is here to help, please reach out on{' '}
            <a href={`tel:${phone}`} rel="noopener noreferrer" target="_blank" className={classes.navLink}>
              {phone}
            </a>{' '}
            for any queries.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} className={classes.button}>
          {t('fields.common.ok', 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
